import { Component, inject, OnInit, signal } from '@angular/core';
import { Ride } from '../../../models/ride';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { RideService } from '../../../services/rides/ride-service';
import { ShowImagesCarouselDialog } from '../../../@shared/dialogs/show-images-carousel-dialog/show-images-carousel-dialog';
import { ApproveEndRidePhotosForm } from '../../../@shared/forms/rides/approve-end-ride-photos-form/approve-end-ride-photos-form';
import { RejectEndRidePhotosForm } from '../../../@shared/forms/rides/reject-end-ride-photos-form/reject-end-ride-photos-form';
import { EndRideForm } from '../../../@shared/forms/rides/end-ride-form/end-ride-form';
import { RideDetailsGeneralInfo } from './ride-details-general-info/ride-details-general-info';
import { RideDetailsBillings } from './ride-details-billings/ride-details-billings';
import { RideDetailsContracts } from './ride-details-contracts/ride-details-contracts';
import { NgClass, TitleCasePipe } from '@angular/common';

@Component({
  selector: 'app-ride-details',
  imports: [NgClass, TitleCasePipe, RideDetailsGeneralInfo, RideDetailsBillings, RideDetailsContracts, ShowImagesCarouselDialog, ApproveEndRidePhotosForm, RejectEndRidePhotosForm, EndRideForm],
  templateUrl: './ride-details.html',
  styleUrl: './ride-details.scss'
})
export class RideDetails implements OnInit {

  rideDetails = signal<Ride | undefined>(undefined)
  rideDetailID: string
  imagesCarouselDialog = false
  approveEndRidePhotosDialog = false
  rejectEndRidePhotosDialog = false
  endRideDialog = false

  activeTab = signal('0');

  private rideService = inject(RideService)
  private router = inject(Router)
  private activatedRoute = inject(ActivatedRoute)
  private location = inject(Location)

  ngOnInit() {
    this.getRideDetails()
    this.restoreTabFromUrl()
  }

  getRideDetails = () => {
    this.rideDetailID = this.activatedRoute.snapshot.paramMap.get('id') as string
    this.rideService.getRideById(this.rideDetailID).subscribe({
      next: (res) => {
        this.rideDetails.set(res.data)
      }
    })
  }

  openImagesCarouselDialog = () => {
    this.imagesCarouselDialog = true
  }

  openApproveEndRidePhotos = () => {
    this.imagesCarouselDialog = false
    this.approveEndRidePhotosDialog = true
  }

  onEndRidePhotosApproved = () => {
    this.getRideDetails()
    this.approveEndRidePhotosDialog = false
  }

  openRejectEndRidePhotos = () => {
    this.imagesCarouselDialog = false
    this.rejectEndRidePhotosDialog = true
  }

  onEndRidePhotosRejected = () => {
    this.getRideDetails()
    this.rejectEndRidePhotosDialog = false
  }

  openEndRideDialog = () => {
    this.endRideDialog = true
  }

  onRideEnded = () => {
    this.getRideDetails()
    this.endRideDialog = false
  }

  get ridePhotos(): string[] {
    return [
      this.rideDetails()!.endRidePhotos?.parkingBoardPhotoUrl
    ].filter(Boolean);
  }

  statusBadgeClass = (status: string | undefined): string => {
    switch (status) {
      case 'ACTIVE':              return 'rd-status--active';
      case 'COMPLETED':           return 'rd-status--completed';
      case 'COMPLETED_WITH_DEBT': return 'rd-status--debt';
      default:                    return 'rd-status--cancelled';
    }
  }

  onTabChange = (tab: string | number | undefined) => {
    const tabValue = String(tab);
    this.activeTab.set(String(tab));
    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: { tab: tabValue },
      queryParamsHandling: 'merge'
    });
  }

  goBack = () => {
    this.location.back();
  }

  restoreTabFromUrl = () => {
    this.activatedRoute.queryParamMap.subscribe(params => {
      const tab = params.get('tab');
      this.activeTab.set(tab ?? '0');
    });
  }
}
